import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { RideDetailsPage } from "./pages/RideDetailsPage";
import "./index.css";

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/ride/noride" replace />} />
        <Route path="/ride/:shareId" element={<RideDetailsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
